import { render, staticRenderFns } from "./ExaminationWrapper.vue?vue&type=template&id=05aeaee4&scoped=true&"
import script from "./ExaminationWrapper.vue?vue&type=script&lang=js&"
export * from "./ExaminationWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationWrapper.vue?vue&type=style&index=0&id=05aeaee4&lang=scss&scoped=true&"
import style1 from "./ExaminationWrapper.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aeaee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
